import { InfoOutlined as HelpIcon } from "@mui/icons-material";
import { SxProps, Tooltip } from "@mui/material";
import { ReactElement, ReactNode } from "react";

import { palette } from "~frontend/theme";

export default function InfoToolip({
  children,
  sx,
}: {
  children: ReactNode;
  sx?: SxProps;
}): ReactElement {
  return (
    <Tooltip title={children}>
      <HelpIcon
        sx={{
          width: "16px",
          marginLeft: 1,
          marginBottom: "2px",
          color: palette.darkGray,
          ...sx,
        }}
      />
    </Tooltip>
  );
}
